import React, { useEffect, useState } from "react";
import { ReactComponent as StarFilledIcon } from "./../../images/svg/starFilled.svg";
import { ReactComponent as StarIcon } from "./../../images/svg/star.svg";
import { cropr } from "../../adapter";

const Star = ({ region }) => {
  const [defaultForecast, setDefaultForecast] = useState(false);
  const onClick = () => {
    window.localStorage.setItem("defaultWeatherRegion" + cropr.farm.id, region.id);
    setDefaultForecast(true);
  };

  useEffect(() => {
    if (
      parseInt(window.localStorage.getItem("defaultWeatherRegion" + cropr.farm.id)) === region.id
    ) {
      setDefaultForecast(true);
    } else {
      setDefaultForecast(false);
    }
  }, [region.id]);

  if (defaultForecast) {
    return (
      <span>
        {/* eslint-disable-next-line */}
        <a className="button--neutral-off is-right">
          <StarFilledIcon />
        </a>
        <div className="is-right">&nbsp;</div>
      </span>
    );
  } else {
    return (
      <span>
        {/* eslint-disable-next-line */}
        <a className="button--neutral-off is-right" onClick={onClick}>
          <StarIcon />
        </a>
        <div className="is-right">&nbsp;</div>
      </span>
    );
  }
};

export default Star;
